import { Modal } from "@/components/ui/modal";

interface ImagePreviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  src?: string;
}

export const ImagePreviewModal: React.FC<ImagePreviewModalProps> = ({
  isOpen,
  onClose,
  src,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="" showHeader={false} size="xl">
      <div className="flex items-center justify-center p-4">
        {src && (
          <img
            src={src}
            alt="Preview"
            className="max-w-full max-h-[80vh] object-contain rounded-xl"
          />
        )}
      </div>
    </Modal>
  );
};
